import { useState } from 'react';
import yellow_block from "../../assets/yellow_block.jpg"
import blue_block from "../../assets/blue_block.jpg"
import green_block from "../../assets/green_block.jpg"
import text_to_speech from "../../assets/text_to_speech.png"
import translate from "../../assets/translate.png"
import teachthought_differentiating from "../../assets/teachthought_differentiating.png"

export function Differentiation() {
  const [docFont, setDocFont] = useState("Helvetica, Arial, sans-serif");
	const [bgColor, setBgColor] = useState("#FFF80");
	const [popupShown, setPopupShown] = useState("");

	let toggle = "";

	function text2Speech(num) {
		const e = document.getElementById("block" + ("00" + num).slice(-2));
		navigator.clipboard.writeText(e.textContent);
		alert(`Text copied to clipboard. Ready to paste.`)
		window.open("https://www.naturalreaders.com");
	}

	function translateText(num) {
		const e = document.getElementById("block" + ("00" + num).slice(-2));
		navigator.clipboard.writeText(e.textContent);
		window.open("http://translate.google.com/?sl=en&tl=th&op=translate&text=" + e.textContent.replaceAll("%", "%25"));
	}

	function addSpeech(num) {
		return <img src={text_to_speech} title="text-to-speech" onClick={() => text2Speech(num)} />;
	}

	function addTranslate(num) {
		return <img src={translate} title="translate" onClick={() => translateText(num)} />;
	}

	function addSpeechAndTranslate(num) {
		return (
			<>
				{addSpeech(num)} &ensp; {addTranslate(num)}
			</>
		);
	}

	function changeFont() {
		const e = document.getElementById("select_font");
		setDocFont(e.value);
	}

	function changeBgColor(bgSelect) {
		setBgColor(bgSelect);
	}

	function bodyClick() {
		if (toggle == "" && popupShown != "") {
			const prev = document.getElementById(popupShown);
			prev.classList.toggle("show");
			setPopupShown("");
		}
	}

	function togglePopup(id) {
		if (id == popupShown) {
			bodyClick();
		}
		else {
			if (popupShown != "") {
				const prev = document.getElementById(popupShown);
				prev.classList.toggle("show");
			}
			const popup = document.getElementById(id);
			popup.classList.toggle("show");
			setPopupShown(id);
		}
		toggle = id;
	}

	document.body.style.backgroundColor = bgColor;
	toggle = "";

  return (
		<>
			<div className="normal-text text-2" style={{ "fontFamily": `${docFont}` }}>
				Select a font: &nbsp;
				<select className="normal-text text-2" id="select_font" style={{ "width": "250px" }} onChange={() => changeFont()}>
					<option defaultValue value="Arial">Arial</option>
					<option value="Arial Black">Arial Black</option>
					<option value="Comic Sans MS">Comic Sans MS</option>
					<option value="Georgia">Georgia</option>
					<option value="Impact">Impact</option>
					<option value="Times New Roman">Times New Roman</option>
				</select>
			</div>
			<br />
			<div className="normal-text text-2" style={{ "fontFamily": `${docFont}` }}>
				Select a background color: &nbsp;
				<img src={yellow_block} onClick={() => changeBgColor("#FFFE91")} /> &nbsp;
				<img src={blue_block} onClick={() => changeBgColor("#99D9EA")} /> &nbsp;
				<img src={green_block} onClick={() => changeBgColor("#A1FB8E")} />
			</div>

			<p>&nbsp;</p>

			<div className="microteach" style={{ "fontFamily": `${docFont}` }} onClick={() => bodyClick()}>
				<h1 style={{ "color": "#000066", "textAlign": "center" }} >Tending the Soil</h1>
				<h2 style={{ "color": "#0000cc", "textAlign": "center" }} >Differentiation in Teaching</h2>

				<div className="media-container">
					<video width="640" controls>
						<source src="http://www.muhre.cloud/teaching/resources/mindfield.mp4" type="video/mp4" />
					</video>
				</div>

				<div className="div-block div-block-extra">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Making a Difference through Differences</h3>
					<table>
						<tbody>
							<tr>
								<td width="85%">
									<label id="block01">
										<p className="paragraph normal-text">
											In a class of twenty students, how many different learning styles should one expect to find?
										</p>
										<p className="indented normal-text">
											<input type="radio" id="1A" name="answer1" value="A" />&nbsp; 3 &nbsp;&nbsp;&nbsp;
											<input type="radio" id="1B" name="answer1" value="B" />&nbsp; 7 &nbsp;&nbsp;&nbsp;
											<input type="radio" id="1C" name="answer1" value="C" />&nbsp; 20 &nbsp;&nbsp;&nbsp;
											<input type="radio" id="1D" name="answer1" value="D" />&nbsp; all of the above &nbsp;&nbsp;&nbsp;
										</p>
										<p className="indented normal-text">
											Enter your own thoughts: <input type="text" className="microteach" style={{ "fontFamily": `${docFont}`, "width": "40vw" }}></input>
										</p>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(1)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block02">
											Differentiation is not just about accommodating students who need it;
											it is a philosophy that acknowledges every student learns differently
											and aims to create an inclusive learning environment for all.
											By implementing differentiation strategies, educators can effectively meet
											the diverse needs of their students and improve overall learning outcomes.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(2)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block03">
											The shift towards differentiated instruction wasn&apos;t an overnight revolution; it was a slow, thoughtful evolution.
											It grew from the understanding that our classrooms are vibrant ecosystems, not assembly lines.
											Educators and researchers began to recognize that students arrive with a vast range of
											backgrounds, readiness levels, interests, and learning profiles.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(3)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block04">
											When students are met where they are, they are more likely to be engaged, motivated, and successful.
											It&apos;s about moving away from a system that inadvertently creates winners and losers
											and toward one that empowers every learner to reach their full potential.
											The beauty of a differentiated classroom is that it normalizes the fact that everyone is on their own unique learning path.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(4)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >All in a Metaphor</h3>
					<div className="media-container" style={{ "marginBottom": "50px" }}>
						<img src="http://www.muhre.cloud/teaching/resources/soil_types.jpg" />
					</div>
					<table align="center">
						<tbody>
							<tr className="paragraph normal-text">
								<td width="75" style={{ "color": "#000000", "fontWeight": "700" }} >Key:</td>
								<td width="100" style={{ "color": "#000000", "fontWeight": "400" }} >Field</td>
								<td>the mind</td>
							</tr>
							<tr className="paragraph normal-text">
								<td width="75">&nbsp;</td>
								<td width="100" style={{ "color": "#000000", "fontWeight": "400" }} >Plants</td>
								<td>the productive output of the mind</td>
							</tr>
							<tr className="paragraph normal-text">
								<td width="75">&nbsp;</td>
								<td width="100" style={{ "color": "#000000", "fontWeight": "400" }} >Soil</td>
								<td>the ecosystem of the mind</td>
							</tr>
							<tr className="paragraph normal-text">
								<td width="75">&nbsp;</td>
								<td width="100" style={{ "color": "#000000", "fontWeight": "400" }} >Nutrients</td>
								<td>learning</td>
							</tr>
						</tbody>
					</table>
					<table>
						<tbody>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block11">
											Soil is not just dirt.
											It&apos;s a mixture of minerals, organic materials, air, and water&mdash;a living, breathing system.
											When that system isn&apos;t working properly, plants will struggle no matter how good your seeds are or care might be.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(11)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block12">
											When soil is regularly disturbed or left bare and exposed to the elements, the underground life begins to collapse,
											forcing plants to rely on feeding and intervention from us, which then leads to weak roots and uneven growth.
											Soil that is treated as a living ecosystem, on the other hand, feeds on autopilot,
											creating the ideal condition for strong growth with far less effort required above ground.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(12)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<p className="paragraph normal-text">
										<label id="block13">
											The state of a field will undoubtedly change over time due to various causes, both external and internal.
											Consistent examination and adjustment is critical.
											When growth slows or foliage starts to look tired, the issue is likely the soil underneath failing to do its job properly.
											Nutrients first need to be processed by the soil life before roots can use them.
											Different soil types have different needs and tolerances.
											Through a calculated process of regular amendment and avoiding disruption,
											any soil will gradually become looser, richer, and easier to work with.
											In turn, plants become more resilient and far less dependent on intervention.
										</label>
									</p>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(13)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Benefits of Differentiated Teaching</h3>
					<table>
						<tbody>
							<tr>
								<td width="85%">
									<label id="block40">
										<p className="paragraph normal-text">
											Differentiated teaching is all about building a universally designed classroom where support is the norm, not the exception.
										</p>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(40)} &ensp; {addTranslate(40)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block41">
										<ul className="paragraph normal-text">
											<li><span style={{ "fontWeight": "600" }}>Increased Student Engagement</span>
												<ul><li>By offering more complex, open-ended tasks,
													you can keep students challenged and engaged instead of just busy.</li></ul>
											</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(41)} &ensp; {addTranslate(41)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block42">
										<ul className="paragraph normal-text">
											<li><span style={{ "fontWeight": "600" }}>Improved Academic Achievement</span>
												<ul><li>Instead of being left to flounder, students receive the scaffolds, resources,
													and targeted instruction they need to grasp the material.</li></ul>
											</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(42)} &ensp; {addTranslate(42)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block43">
										<ul className="paragraph normal-text">
											<li><span style={{ "fontWeight": "600" }}>Greater Student Ownership</span>
												<ul><li>Differentiation gives students the chance to explore topics they&apos;re passionate about
													and demonstrate their knowledge in ways that play to their strengths,
													pushing them from proficient to exemplary.</li></ul>
											</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(43)} &ensp; {addTranslate(43)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block44">
										<ul className="paragraph normal-text">
											<li><span style={{ "fontWeight": "600" }}>Fostering of Positive Classroom Community</span>
												<ul><li>Grouping students with supportive peers for process activities can be incredibly powerful.</li></ul>
											</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(44)} &ensp; {addTranslate(44)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block45">
										<ul className="paragraph normal-text">
											<li><span style={{ "fontWeight": "600" }}>Reduced Behavioral Issues</span>
												<ul><li>Classroom management routines and anchor activities help maintain order in a dynamic, differentiated classroom.</li></ul>
											</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeech(45)} &ensp; {addTranslate(45)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Proven Strategies to Implement Differentiated Instruction</h3>
					<table align="center">
						<tbody>
							<tr>
								<td width="350" height="50">
									<label id="block50">
										<div className="popup normal-text" onClick={() => togglePopup("flexible_grouping")}><u>Flexible Grouping</u>
											<span className="popuptext" id="flexible_grouping">
												This is your bread and butter.
												Move students between whole-group, small-group, partner, and individual work fluidly.
												Groups can be formed based on readiness, interest, or even student choice.
												This keeps the classroom dynamic and responsive.
												<br /><br />
												{addSpeech(50)}	&emsp; {addTranslate(50)}
											</span>
										</div>
									</label>
								</td>
								<td width="350" height="50">
									<label id="block51">
										<div className="popup normal-text" onClick={() => togglePopup("tiered_assignments")}><u>Tiered Assignments</u>
											<span className="popuptext" id="tiered_assignments">
												The goal is the same, but the path is different.
												All students work on the same core concept, but the task is tiered by complexity, depth, or level of support.
												For example, in a math lesson on fractions, some students might work on identifying fractions from pictures,
												while others solve complex word problems.
												<br /><br />
												{addSpeech(51)}	&emsp; {addTranslate(51)}
											</span>
										</div>
									</label>
								</td>
							</tr>
							<tr>
								<td width="350" height="50">
									<label id="block52">
										<div className="popup normal-text" onClick={() => togglePopup("learning_centers")}><u>Learning Centers/Stations</u>
											<span className="popuptext" id="learning_centers">
												A fantastic way to manage multiple activities at once.
												Set up different stations around the room, each focused on a different skill or activity related to your topic.
												Students rotate through them, giving you a chance to work with a small group at your teacher table.
												<br /><br />
												{addSpeech(52)}	&emsp; {addTranslate(52)}
											</span>
										</div>
									</label>
								</td>
								<td width="350" height="50">
									<label id="block53">
										<div className="popup normal-text" onClick={() => togglePopup("choice_boards")}><u>Choice Boards (or Menus)</u>
											<span className="popuptext" id="choice_boards">
												Empower your students with choice!
												Create a grid of activities (like a tic-tac-toe board) where students must complete a certain number of tasks.
												You can structure it so they have to choose activities that cover different skills or levels of thinking.
												<br /><br />
												{addSpeech(53)}	&emsp; {addTranslate(53)}
											</span>
										</div>
									</label>
								</td>
							</tr>
							<tr>
								<td width="350" height="50">
									<label id="block54">
										<div className="popup normal-text" onClick={() => togglePopup("compacting")}><u>Compacting</u>
											<span className="popuptext" id="compacting">
												Perfect for your advanced learners.
												Pre-assess to see what students already know.
												If they demonstrate mastery, they can &quot;compact&quot; the curriculum
												(i.e., skip the instruction and practice they don&apos;t need)
												and move on to more challenging enrichment projects.
												<br /><br />
												{addSpeech(54)}	&emsp; {addTranslate(54)}
											</span>
										</div>
									</label>
								</td>
								<td width="350" height="50">
									<label id="block55">
										<div className="popup normal-text" onClick={() => togglePopup("varied_questioning")}><u>Varied Questioning</u>
											<span className="popuptext" id="varied_questioning">
												Use Bloom&apos;s Taxonomy as your guide.
												Ask questions that range from simple recall to higher-level synthesis and evaluation.
												This pushes all students to think more deeply.
												<br /><br />
												{addSpeech(55)}	&emsp; {addTranslate(55)}
											</span>
										</div>
									</label>
								</td>
							</tr>
							<tr>
								<td width="350" height="50">
									<label id="block56">
										<div className="popup normal-text" onClick={() => togglePopup("learning_contracts")}><u>Learning Contracts</u>
											<span className="popuptext" id="learning_contracts">
												A great tool for promoting accountability.
												A learning contract is an agreement between you and the student that outlines what they will learn,
												how they will learn it, and how they will be assessed.
												It gives students a clear roadmap and a sense of ownership.
												<br /><br />
												{addSpeech(56)}	&emsp; {addTranslate(56)}
											</span>
										</div>
									</label>
								</td>
								<td width="350" height="50">
									<label id="block57">
										<div className="popup normal-text" onClick={() => togglePopup("jigsaw_method")}><u>Jigsaw Method</u>
											<span className="popuptext" id="jigsaw_method">
												This cooperative learning strategy is brilliant for differentiating content.
												Divide a topic into smaller pieces.
												Each student in a &quot;home group&quot;
												becomes an &quot;expert&quot; on one piece by working with experts from other groups.
												They then return to their home group to teach their piece to their peers.
												<br /><br />
												{addSpeech(57)}	&emsp; {addTranslate(57)}
											</span>
										</div>
									</label>
								</td>
							</tr>
							<tr>
								<td width="350" height="50">
									<label id="block58">
										<div className="popup normal-text" onClick={() => togglePopup("graphic_organizers")}><u>Graphic Organizers</u>
											<span className="popuptext" id="graphic_organizers">
												These visual tools are a lifeline for so many students.
												Use Venn diagrams, flow charts, Frayer models, and mind maps to help students organize their thinking,
												break down complex information, and see connections.
												<br /><br />
												{addSpeech(58)}	&emsp; {addTranslate(58)}
											</span>
										</div>
									</label>
								</td>
								<td width="350" height="50">
									<label id="block59">
										<div className="popup normal-text" onClick={() => togglePopup("anchor_activities")}><u>Anchor Activities</u>
											<span className="popuptext" id="anchor_activities">
												What do students do when they finish their work early?
												Have a set of meaningful, ongoing activities they can work on.
												This could be silent reading, journaling, working on a long-term project, or practicing skills on an educational app.
												This prevents &quot;I&apos;m done!&quot; chaos and makes every minute count.
												<br /><br />
												{addSpeech(59)}	&emsp; {addTranslate(59)}
											</span>
										</div>
									</label>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block div-block-extra">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Requirements for Differentiated Instruction</h3>
					<div className="media-container">
						<a href="https://www.teachthought.com/pedagogy-posts/ways-to-differentiate-instruction/" target="_blank">
							<img src={teachthought_differentiating} />
						</a>
					</div>
					<table>
						<tbody>
							<tr>
								<td width="85%">
									<label id="block21">
										<ul className="paragraph normal-text">
											<li>Tailoring content, process, product, and environment to meet every student&apos;s unique needs</li>
											<li>Ongoing assessment to identify readiness levels and guide your instructional decisions</li>
											<li>Flexible grouping, tiered assignments, and choice boards</li>
											<li>Technology tools to boost engagement</li>
											<li>Classroom management routines and anchor activities to help maintain order</li>
											<li>Proactive (NOT reactive) planning</li>
											<li>Smarter work&mdash;making strategic tweaks and offering choices</li>
										</ul>
									</label>
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(21)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block div-block-extra">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Frequent Objections to Differentiated Instruction (with responses)</h3>
					<table>
						<tbody>
							<tr>
								<td width="85%">
									<label id="block31">
										<div className="paragraph heavy-text">
											&quot;I don&apos;t have time to plan all these different activities!&quot;
											<ul className="paragraph normal-text" type="circle">
												<li>Start small.</li>
												<li>Don&apos;t try to differentiate every subject every day.</li>
												<li>Pick one lesson a week.</li>
												<li>Communicate and collaborate with other teachers on your grade level to share the workload.</li>
												<li>You don&apos;t have to reinvent the wheel.</li>
											</ul>
										</div>
									</label>
									<br />
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(31)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block32">
										<div className="paragraph heavy-text">
											&quot;Isn&apos;t it unfair to give students different work?&quot;
											<ul className="paragraph normal-text" type="circle">
												<li>Reframe your thinking&mdash;fair isn&apos;t always equal.</li>
												<li>Fairness is NOT giving everyone the same thing.</li>
												<li>Fairness is giving each person what they need to succeed.</li>
											</ul>
										</div>
									</label>
									<br />
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(32)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block33">
										<div className="paragraph heavy-text">
											&quot;This is impossible with 35 students!&quot;
											<ul className="paragraph normal-text" type="circle">
												<li>Lean heavily on routines, anchor activities, and flexible grouping.</li>
												<li>When students know the expectations and can work independently, it frees you up to work with small groups.</li>
												<li>Technology can also be a huge help in managing a large class.</li>
											</ul>
										</div>
									</label>
									<br />
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(33)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block34">
										<div className="paragraph heavy-text">
											&quot;How do I grade all these different products and assignments?&quot;
											<ul className="paragraph normal-text" type="circle">
												<li>Use rubrics that focus on the core learning objectives, not the format.</li>
												<li>The essential skills and knowledge you&apos;re assessing should be the same for everyone, even if the path to demonstrating them looks different.</li>
											</ul>
										</div>
									</label>
									<br />
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(34)}
								</td>
							</tr>
							<tr>
								<td width="85%">
									<label id="block35">
										<div className="paragraph heavy-text">
											&quot;It&apos;s too demanding! I&apos;ll never get it right!&quot;
											<ul className="paragraph normal-text" type="circle">
												<li>Be patient with yourself.</li>
												<li>This is a practice, not a destination.</li>
												<li>Some days will be messy, and that&apos;s okay!</li>
												<li>Every attempt is a learning experience.</li>
											</ul>
										</div>
									</label>
									<br />
								</td>
								<td align="center" valign="middle">
									{addSpeechAndTranslate(35)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="div-block">
					<h3 style={{ "color": "#000000", "textAlign": "left" }} >Sources</h3>
					<label id="block99">
						<ul className="paragraph normal-text">
							<li><a href="https://eos.com/blog/types-of-soil/">
								EOS Data Analytics: &quot;Types of Soil in Agriculture to Grow Crops Efficiently&quot; </a></li>
							<li><a href="https://thebackyardpros.com/types-of-soil/">
								The Backyard Pros: &quot;The 6 Different Types of Soil&quot; </a></li>
							<li><a href="https://www.youtube.com/watch?v=jcR6uFnl8qs">
								Sheffield Made Gardens: &quot;The Secret to Building the Perfect Soil&quot; </a></li>
							<li><a href="https://www.teacherstrategies.org/how-can-i-differentiate-instruction-to-meet-the-diverse-needs-of-my-students/">
								Teacher Strategies: &quot;7 Powerful Ways to Differentiate Instruction for Diverse Learners&quot; </a></li>
							<li><a href="https://thirdspacelearning.com/blog/differentiation-in-teaching/">
								Third Space Learning: &quot;A Teacher&apos;s Guide to Using Effective Differentiation in Teaching&quot; </a></li>
						</ul>
					</label>
				</div>

			</div>
		</>
  );
}
